import { useDispatch, useSelector } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from 'react';
import { deleteProfile } from '../../store/reducers/profile.reducer';
import { PATHS } from '../../router/paths';

export const useDeleteProfile = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const { deleteStatus, error } = useSelector((state) => state.profile);

    const handleDelete = useCallback(async () => {
        if (!keycloak.token) {
            console.error("Cannot delete profile: not authenticated.");
            return;
        }

        const resultAction = await dispatch(deleteProfile(keycloak.token));

        if (deleteProfile.fulfilled.match(resultAction)) {
            keycloak.logout({ redirectUri: window.location.origin + PATHS.defaultAfterLogout });
        } else {
            console.error("Failed to delete profile:", resultAction.payload);
        }

    }, [dispatch, keycloak]);

    return {
        handleDelete,
        deleteStatus,
        error
    };
};